import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      items: [],
      swiperOptions: {
        loop: false,
        autoplay: 5000,
        direction: 'horizontal',
        pagination: '.hero-unit-slider__pagination',
        paginationClickable: true,
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    ...mapActions('browse', ['getCarousel']),
    onNavigate(banner) {
      if (banner.carouselData.carouselItemButton.url) {
        window.location.href = banner.carouselData.carouselItemButton.url;
      } else if (banner.carouselData.marketId) {
        this.$router.push(
          { name: 'market-details', params: { marketId: banner.carouselData.marketId } },
        );
      }
    },
    bannerImageStyleModifiers(url) {
      if (!url) return {};
      return {
        'background-image': `url('${url}')`,
      };
    },
    buttonStyleModifiers(button) {
      const styles = {};
      if (button.backgroundColor) {
        styles.backgroundColor = button.backgroundColor;
        styles.borderColor = button.backgroundColor;
      }
      return styles;
    },
  },
  created() {
    this.getCarousel()
      .then((data) => {
        this.items = data;
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/landing-pages/hero-unit-slider/hero-unit-slider.js